<template>
    <div id="app" class="panel-constructor">
        <div id="editor-content">

            <component v-for="(element,index) in elements" :key="index" :is="element.name" :config="element.config"
                       :childs="element.childs">
            </component>

            <sweet-modal v-for="(popup, index) in userPopups" :key="'popup' + popup.id" :ref="'popup' + popup.id"
                         width="100%">
                <component v-for="(element,index2) in  JSON.parse(popup.content)" :key="index2" :is="element.name"
                           :config="element.config"
                           :childs="element.childs">
                </component>
            </sweet-modal>

            <sweet-modal ref="videoModal" v-on:close="yourHandlerForCloseHere">
                <iframe width="990" height="500" ref="videoModalIframe" class="desktop-element"  frameborder="0" allowfullscreen></iframe>
                <iframe  style="margin-left: 5%;" width="330" height="315" ref="videoModalIframeMobile" class="mobile-element" frameborder="0" allowfullscreen></iframe>
            </sweet-modal>

            <sweet-modal icon="error" ref="required_fields">
                <div style="padding-top: 20px">
                    <p v-for="message in errorMessage">{{ message }}</p>
                </div>
            </sweet-modal>


            <sweet-modal icon="success" red="success_send">
                Message sent successfully
            </sweet-modal>

        </div>
    </div>
</template>

<script>


	require('./components/base/editor/editor.scss')

	import PanelElement from "./components/apps/Panel/Panel.vue";
	import {SweetModal} from 'sweet-modal-vue'


	export default {
		name: 'app',
		components: {
			PanelElement,
			SweetModal
		},
		data() {
			return {
				errorMessage : [],
				elements: [],
				userPopups: [],
				fontGroup: {},
				popupKeys: [],
				bgPropsPage: {}
			}
		},
		methods: {

			yourHandlerForCloseHere(){
				this.$refs.videoModalIframe.src = '';
				this.$refs.videoModalIframeMobile.src = '';
            },

			applyFontGroup: function () {
				Object.keys(this.fontGroup).forEach(font => {
					document.body.style.setProperty('--text-family-' + font, this.fontGroup[font].family);
					document.body.style.setProperty('--text-size-' + font, this.fontGroup[font].size);
					document.body.style.setProperty('--text-size-mobile-' + font, this.fontGroup[font].sizeMobile);
					document.body.style.setProperty('--text-color-' + font, this.fontGroup[font].color);
					document.body.style.setProperty('--text-line-height-' + font, this.fontGroup[font]['line-height']);
				});
			},

			applyBackground() {
				let bg = this.bgPropsPage.backgroundColor;


				if (this.bgPropsPage.backgroundImage !== 'none') {
					bg += ' url("' + this.bgPropsPage.backgroundImage + '")';
					bg += ' ' + this.bgPropsPage.backgroundPosition;
					bg += ' / ' + this.bgPropsPage.backgroundSize;
					bg += ' ' + this.bgPropsPage.backgroundRepeat;
					bg += ' ' + this.bgPropsPage.backgroundOrigin;
				}


				document.body.style.setProperty('--bg-page', bg);
			},


		},
		mounted() {

			var query = location.hash;
			if (query != '') {
				if (query.indexOf('aid') >= 0) {
					var aid = query.split('&')[0];
					window.aid_office = aid;
					let OPTIONS_INIT_SITE = {};
					OPTIONS_INIT_SITE.options = {};
					OPTIONS_INIT_SITE.options.dominio_original = window.location.host;
					OPTIONS_INIT_SITE.options.domain = window.location.host;
					OPTIONS_INIT_SITE.options.lang = 'en_US';

					window.OPTIONS_INIT_SITE = OPTIONS_INIT_SITE


					var script = document.createElement('script');

					script.setAttribute('src', 'https://office.builderall.com/scripts/pixel/pixel-bundle.js');

					document.head.appendChild(script);

					var script2 = document.createElement('script');

					script2.setAttribute('src', 'https://office.builderall.com/scripts/funis/complements.js');

					document.head.appendChild(script2);
				}
			}

			this.$root.$on('linkAction', (link) => {

				switch (link.type) {

					case 'web' : {

						if (link.value !== '') {
							if (link.target === '_blank') {
								window.open(link.value, '_blank');
							} else {
								window.location.href = link.value
							}
						}
						break;
					}
					case 'page' : {

						pagesConfig.forEach(page => {
							if (link.valueID == page.id) {
								if (link.target === '_blank') {
									window.open('/' + page.url, '_blank');
								} else {
									window.location.href = '/' + page.url
								}
							}
						});
						break;
					}
					case 'anchor' : {
						let pageAnchor = {};
						let anchorName = '';
						pagesConfig.forEach(page => {

							if (typeof page !== 'undefined' && typeof page.configs !== 'undefined') {
								page.configs.forEach(config => {
									if (config.key === 'anchors') {
										let anchors = JSON.parse(config.value);
										if (typeof anchors[link.valueID] !== 'undefined') {
											pageAnchor = page;
											anchorName = anchors[link.valueID];
										}
									}
								});
							}
						});

						if (anchorName !== '')
							window.location.href = '/' + pageAnchor.url + '#' + anchorName;

						break;
					}

					case 'popup' : {
						let vm = this;
						console.log(this.userPopups);

						this.userPopups.forEach(popup => {
							console.log(popup);
							if (link.valueID == popup.id) {
								vm.$refs['popup' + popup.id][0].open();
							}
						})
						break;
					}
					case 'video' : {
						if (link.value !== '') {

							this.$refs.videoModalIframe.src = link.value;
							this.$refs.videoModalIframeMobile.src = link.value;
							this.$refs.videoModal.open();
						}

						break;
					}
				}
			});

			this.$root.$on('errorMessagePopup', (errors) => {
				this.errorMessage = errors;
				this.$refs.required_fields.open();
			});
			this.$root.$on('successMessagePopup', () => {
				this.$refs.success_send.open();
			});

			this.$root.$on('applyAnimation', (vm, defaultClass) => {
				//clean and restore default classes
				vm.$el.className = '';
				$(vm.$el).off(".animation");
				vm.$el.classList.add(defaultClass);

				//prep;
				let animation = vm.internal_config.animation.in;

				//apply
				let infinite = animation.infinite === true ? vm.$el.classList.add('infinite') : '';
				vm.$el.classList.add(animation.speed);

				//apply time
				switch (animation.action) {
					case 'time':
						setTimeout(function () {
							vm.$el.classList.add(animation.effect, 'animated');
						}, animation.time * 1000);
						break;
					case 'click':
						$(vm.$el).on('click.animation', () => {
							vm.$el.classList.add(animation.effect, 'animated');
							if (!infinite) {
								vm.$el.addEventListener('animationend', function () {
									vm.$root.$emit('applyAnimation', vm, defaultClass);
								});
							}
						});
						break;
					case 'hover':
						$(vm.$el).on('mouseover.animation', () => {
							vm.$el.classList.add(animation.effect, 'animated');
							if (!infinite) {
								vm.$el.addEventListener('animationend', function () {
									vm.$root.$emit('applyAnimation', vm, defaultClass);
								});
							}
						});
						break;
					case 'scroll':

						let element = document.getElementById(vm.$el.id),
							bodyRect = document.body.getBoundingClientRect(),
							elemRect = element.getBoundingClientRect(),
							offset = elemRect.top - bodyRect.top;

						document.addEventListener('scroll', function () {
							if (window.pageYOffset >= offset) {
								vm.$el.classList.add(animation.effect, 'animated');
							}
						}, true /*Capture event*/);
						break;
				}
			})
			let uri = window.location.search.substring(1);
			let params = new URLSearchParams(uri);
			this.elements = config;

			if (typeof popupConst !== 'undefined') {
				this.userPopups = popupConst;

			}
			this.fontGroup = fontConfig;

			// this.popupKeys = Object.keys(popupConst);

			this.applyFontGroup();

			if (window.location.pathname === '/') {

				let actualPage;

				pagesConfig.forEach((page) => {

					if (page !== null && page.initial === '1') {
						actualPage = page;
					}
				})

				if (typeof actualPage !== 'undefined' && typeof actualPage.configs !== 'undefined') {

					let pageConfig = actualPage.configs;
					Object.keys(pageConfig).forEach((idx) => {
						let config = pageConfig[idx];
						if (config.key === "bgPropsPage") {
							this.bgPropsPage = JSON.parse(config.value)
							this.applyBackground();
						}
					})

				}

			} else {

				let url = window.location.pathname.replace('/', '');

				if (typeof pagesConfig !== 'undefined' && typeof pagesConfig[url] !== 'undefined' && pagesConfig[url].config !== null) {

					let pageConfig = pagesConfig[url].config;
					pageConfig.forEach((config) => {
						if (config.key === "bgPropsPage") {
							this.bgPropsPage = JSON.parse(config.value)
							this.applyBackground();

						}
					})

				}

			}

			let hash = window.location.hash.substr(1);
			if (hash !== '') {
				setTimeout(function () {
				    document.getElementById(hash).scrollIntoView({behavior: 'smooth'});
				}, 2000)
			}

			this.applyBackground();
		}


	}
</script>

<style>

    @media (max-width: 980px) {

        .desktop-element {
            display: none;
        }

        .mobile-element {
            display: block;
        }

        .sitebuilder-element-container {
            position: relative !important;
            left: 0 !important;
            top: 0 !important;
            height: auto !important;
            width: auto !important;
            padding-top: 15px;
            padding-bottom: 15px;
        }

        .container-fluid {
            height: auto !important;
        }

        [element="ImageComponent"] img {
            width: 100% !important;
            max-width: 400px;
            height: auto !important;

        }

        [element="ImageComponent"] {

            text-align: center;
        }

    }

    @media (min-width: 979px) {

        .desktop-element {
            display: block;
        }

        .mobile-element {
            display: none;
        }

    }

</style>
